import { createContext, useContext } from "react";

/**
 * Shared state for the org chart node action menus.
 *
 * The menu state deliberately lives on the chart rather than on each node, so
 * that only one menu can be open at a time and so the chart can dismiss it from
 * a pane click or the Escape key. The Add Relationship pane is hoisted for the
 * same reason: one instance for the whole chart instead of one per node.
 */
export type OrgChartMenuContextValue = {
  /** id of the node whose action menu is open, or null when none is open */
  openNodeId: string | null;
  toggleMenu: (nodeId: string) => void;
  openMenu: (nodeId: string) => void;
  closeMenu: () => void;
  /** opens the single shared Add Relationship pane for the given node's data */
  openAddRelationship: (nodeData: any) => void;
};

const noop = () => undefined;

export const OrgChartMenuContext = createContext<OrgChartMenuContextValue>({
  openNodeId: null,
  toggleMenu: noop,
  openMenu: noop,
  closeMenu: noop,
  openAddRelationship: noop,
});

export const useOrgChartMenu = () => useContext(OrgChartMenuContext);
